import { IBookingSessionBlockBookingBase } from '../../models/bookings';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IConfirmSessionBlockBookingsServiceProps {
  blockId: string;
  bookingId: string;
}

export async function confirmSessionBlockBookingsService({
  blockId,
  bookingId,
}: IConfirmSessionBlockBookingsServiceProps): Promise<IBookingSessionBlockBookingBase> {
  const { data } = await jhsfBookingsApi.post<IBookingSessionBlockBookingBase>(
    `/activities/session-blocks/${blockId}/bookings/${bookingId}/confirm`,
    {},
  );

  return data;
}
